export const RESET_DASHBOARDS = "RESET_DASHBOARDS";
export const RESET_ERROR = "DASHBOARDS_RESET_ERROR";

export const GET_DASHBOARDS = "GET_DASHBOARDS";
export const SET_DASHBOARDS = "SET_DASHBOARDS";

export const API_ERROR = "DASHBOARDS_API_ERROR";
